import React from 'react';
import { AuthContext } from "../../../authContext";
import AppContent from "../../shared/AppContent";
import Flex from "../../shared/Flex";
import WebLink from "../../shared/WebLink";
import BreadcrumbSeparator from "../../shared/BreadcrumbSeparator";
import PageHeading from "../../shared/PageHeading";
import Alert from "../../shared/Alert";
import Image from "../../shared/Image";
import biodiversityImage from "../../../assets/images/queens-wood.png";

class BiodiversityNetGain extends React.Component {
    static contextType = AuthContext;

    componentDidMount() {
        if (!this.context.isLoggedIn) {
            this.context.navigate('/');
        }
    }

    render() {
        return (
            <AppContent>
                <Flex justifyContent={`flex-start`}>
                    <WebLink onClick={() => this.context.navigate(`/analysis`)} >Analysis</WebLink>
                    <BreadcrumbSeparator />
                    <div>Biodiversity Net Gain Analysis</div>
                </Flex>
                <PageHeading>
                    Biodiversity Net Gain Analysis
                </PageHeading>
                <Alert>
                  <strong>You are not connected to the CityCAD / BIAM server. Please check your permissions.</strong>
                </Alert>
                <Image src={biodiversityImage} />
            </AppContent>
        )
    }
}

export default BiodiversityNetGain;